import React, { useState, useCallback } from "react";

import { Button, DefaultPopover, Separator } from "twyne-new.ui"

import Form from "./Form";

export default function FormPopover({ data, version, onCreate }) {
  const [open, setOpen] = useState(false)

  const handleCreate = useCallback(async version => {
    await onCreate(version)
    setOpen(false)
  }, [onCreate])

  return <DefaultPopover
    trigger={<Button color="accent">Create new version</Button>}
    contentProps={{ size: "top" }}
    wrapperProps={{ open, onOpenChange: setOpen }}
  >
    <p className="font-bold">Create new version</p>
    <Separator className="m-0 my-2" />
    <Form data={data} onCancel={() => setOpen(false)}
      version={version} onSubmit={handleCreate} />
  </DefaultPopover>
}
